import {
  Plus,
  TruckTrailer,
  Buildings,
  PaperPlaneTilt,
} from '@phosphor-icons/react';
import { useScreenView } from '../../utils/ScreenViewContext';
import { AccentButton } from '../../shared/Buttons';

const demoReferredBrokers = [
  {
    id: 'broker-1',
    name: 'Freight Alliance Logistics',
    contactName: 'John Carter',
    email: 'jcarter@freightalliance.com',
    phone: '(214) 555-0192',
    status: 'pending' as const,
    submittedAt: '2026-03-10',
  },
  {
    id: 'broker-2',
    name: 'Summit Freight Group',
    contactName: 'Lisa Nguyen',
    email: 'lisa@summitfreight.com',
    phone: '(312) 555-0847',
    status: 'approved' as const,
    submittedAt: '2026-02-22',
  },
];

const statusStyles = {
  pending: 'bg-yellow-100 text-yellow-700',
  approved: 'bg-green-100 text-green-700',
  rejected: 'bg-red-100 text-red-700',
};

function DemoBrokerNetwork() {
  const { screenView } = useScreenView();

  return (
    <div
      className={`flex h-full flex-col space-y-6 overflow-auto py-4 ${
        screenView === 'mobile'
          ? 'w-[95%]'
          : screenView === 'tablet'
            ? 'w-full px-4'
            : 'w-[1148px] max-w-[1148px]'
      }`}
    >
      <div className="flex flex-col space-y-1">
        <h2 className="text-lg font-semibold text-primary">
          Refer Your Brokers
        </h2>
        <p className="text-sm text-graysecondary">
          Refer the freight brokers you work with to TACH. Once approved, you
          can receive loads and payments directly through the platform.
        </p>
      </div>

      {/* Refer a Broker Form */}
      <div className="rounded-lg border border-bordergray bg-white p-5">
        <div className="mb-4 flex items-center gap-2">
          <Plus size={18} className="text-ctadarkgreen" weight="bold" />
          <h3 className="text-sm font-semibold text-primary">
            Refer a New Broker
          </h3>
        </div>
        <div className="grid gap-4 opacity-50 md:grid-cols-2">
          <div>
            <label className="mb-1 block text-xs text-graysecondary">
              Broker / Company Name *
            </label>
            <input
              type="text"
              placeholder="e.g. ABC Freight LLC"
              disabled
              className="w-full cursor-not-allowed rounded-lg border border-bordergray bg-primarybg p-2.5 text-sm text-primary outline-none"
            />
          </div>
          <div>
            <label className="mb-1 block text-xs text-graysecondary">
              Contact Name
            </label>
            <input
              type="text"
              placeholder="e.g. Jane Smith"
              disabled
              className="w-full cursor-not-allowed rounded-lg border border-bordergray bg-primarybg p-2.5 text-sm text-primary outline-none"
            />
          </div>
          <div>
            <label className="mb-1 block text-xs text-graysecondary">
              Contact Email *
            </label>
            <input
              type="email"
              placeholder="e.g. jane@abcfreight.com"
              disabled
              className="w-full cursor-not-allowed rounded-lg border border-bordergray bg-primarybg p-2.5 text-sm text-primary outline-none"
            />
          </div>
          <div>
            <label className="mb-1 block text-xs text-graysecondary">
              Phone Number
            </label>
            <input
              type="tel"
              placeholder="e.g. (555) 123-4567"
              disabled
              className="w-full cursor-not-allowed rounded-lg border border-bordergray bg-primarybg p-2.5 text-sm text-primary outline-none"
            />
          </div>
        </div>
        <div className="mt-4 flex justify-end">
          <AccentButton
            onClick={() => {}}
            disabled
            addClass="rounded-full px-6 py-2 opacity-50 cursor-not-allowed"
          >
            <div className="flex items-center gap-2">
              <PaperPlaneTilt size={16} weight="bold" />
              <p>Submit Referral</p>
            </div>
          </AccentButton>
        </div>
      </div>

      {/* Referred Brokers List */}
      <div>
        <h3 className="mb-3 text-sm font-semibold text-primary">
          Your Referred Brokers
        </h3>
        <div className="flex flex-col gap-3">
          {demoReferredBrokers.map((broker) => (
            <div
              key={broker.id}
              className="flex flex-col gap-3 rounded-lg border border-bordergray bg-white p-4 md:flex-row md:items-center md:justify-between"
            >
              <div className="flex items-start gap-3">
                <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-primarybg">
                  <Buildings size={20} className="text-graysecondary" />
                </div>
                <div className="flex flex-col">
                  <p className="text-sm font-semibold text-primary">
                    {broker.name}
                  </p>
                  <p className="text-xs text-graysecondary">
                    {broker.contactName} &middot; {broker.email}
                  </p>
                  <p className="mt-0.5 text-xs text-graysecondary">
                    Submitted {broker.submittedAt}
                  </p>
                </div>
              </div>
              <span
                className={`self-start rounded-full px-3 py-1 text-xs font-medium capitalize md:self-center ${statusStyles[broker.status]}`}
              >
                {broker.status}
              </span>
            </div>
          ))}
        </div>
      </div>

      {demoReferredBrokers.length === 0 && (
        <div className="flex flex-col items-center justify-center gap-2 rounded-lg border border-bordergray bg-white py-12">
          <TruckTrailer size={40} className="text-graysecondary" />
          <p className="text-sm text-graysecondary">
            You haven't referred any brokers yet.
          </p>
        </div>
      )}
    </div>
  );
}

export default DemoBrokerNetwork;
